import { Box } from '@mui/material';
import { TournamentPlayerStatus } from '@okletsplay/core';
import { EntityStoreName } from 'app/enums/store';
import { useEntityRepositoryStatus } from 'app/hooks/store';
import { TournamentAlert } from 'shared/components/TournamentAlert';
import { CurrentTournamentStoreStatus } from 'modules/tournaments/store/current-tournament/enum';
import { updateInvitationStatus } from 'modules/tournaments/store/current-tournament/repository';
import { currentTournamentSelector } from 'modules/tournaments/store/current-tournament/selectors';
import React, { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LoaderButton } from 'shared/components/LoaderButton/LoaderButton';
import { useStyles as usePulseAnimationStyles } from 'shared/styles/PulseAnimation.styles';

export const TournamentCheckin: FC = () => {
  const { classes: pulseAnimationClasses } = usePulseAnimationStyles();
  const isCheckinAvailable = useSelector(currentTournamentSelector.isCheckinAvailable);
  const tournamentId = useSelector(currentTournamentSelector.tournament)?.id;
  const teamId = useSelector(currentTournamentSelector.myTeam)?.id;

  const dispatch = useDispatch();

  const updating = useEntityRepositoryStatus({
    [EntityStoreName.CurrentTournament]: CurrentTournamentStoreStatus.UpdatingInvitationStatus,
  });

  const onClickHandler = useCallback(() => {
    if (!tournamentId || !teamId) {
      return;
    }

    dispatch(
      updateInvitationStatus({
        identifier: tournamentId,
        data: { teamId: teamId, status: TournamentPlayerStatus.Ready },
      })
    );
  }, [dispatch, teamId, tournamentId]);

  if (!isCheckinAvailable) {
    return null;
  }

  return (
    <Box mt={1}>
      <TournamentAlert
        title={`I’m ready to play!`}
        controls={
          <LoaderButton
            color="primary"
            variant="contained"
            loading={updating}
            onClick={onClickHandler}
            className={pulseAnimationClasses.pulse}
          >
            Check-In
          </LoaderButton>
        }
      />
    </Box>
  );
};
